import React from "react";
import { ListGroupItem } from "react-bootstrap";
import Plot from "react-plotly.js";
import { isEmpty, keys, pickBy, sortBy, } from "lodash";

export default function FeatureBox({
	error,
	loading,
	refIndic,
	setRef,
	infos,
	infosCompare,
	timeActivated,
}) {
	let data = [];

	const refIndicInfos = refIndic[setRef.toUpperCase()];

	const barData = (featureProps, color = "#078aa3") => {
		const findYear = (keyName) => {
			return featureProps[keyName] || String(new Date(featureProps?.date_data).getFullYear())
		};
		if (featureProps.data_discr) {
			return [
				{
					type: "bar",
					orientation: "h",
					x: [featureProps.data_discr],
					y: [
						`${String(refIndic[featureCompo].nom)} - ${findYear()}\u2003`,
					],
					composante: refIndic[featureCompo],
					marker: {
						color: color,
					},
					text: [featureProps.data_discr], // Ajout des valeurs sur les barres
					textposition: "outside",
				},
			];
		}
		let subIndic = pickBy(featureProps, (i, j) =>
			keys(refIndic).includes(j.toUpperCase())
		);

		return keys(subIndic).map((indic) => {
			// const f = [...data];
			// console.log(f);
			const refIndicInfo = refIndic[indic.toUpperCase()];
			let niveau = refIndicInfo.niveau;
			let nameIndice = String(refIndicInfo.nom);
			const year = findYear(`annee_${indic}`);
			const barExists = data.filter(x => x.name == nameIndice && x.year == year);
			if (barExists.length) {
				// use space to avoid the bar to be merged
				nameIndice = " " + nameIndice;
			}
			let current = indic && setRef === indic.toUpperCase();
			return {
				type: "bar",
				orientation: "h",
				x: [featureProps[indic]],
				y: [`${nameIndice} - ${year}\u2003`,],
				marker: {
					color: current ? "grey" : color,
					// Récupération de la couleur de la composante
					// color: refColor[.toUpperCase()[0]]
				},
				current: current,
				text: [featureProps[indic]],
				composante: refIndicInfo.composante,
				name: nameIndice,
				year: year,
				ref: indic,
				niveau: niveau,
				textposition: "outside",
				}}
		);
	};

	// Composante Bar chart colors
	// const refColor = {
	// 	A: "#e03c3b",
	// 	E: "#f7b733",
	// 	G: "#449d44",
	// 	R: "#31b0d5",
	// 	I: "#dedede"
	// };

	if (loading) {
		return <div className="loader"></div>;
	}

	if (error || isEmpty(infos) || !setRef) {
		return null;
		// <div>Error! {error.message}</div>;
	}

	const propFeature = infos.properties;

	let composition = refIndicInfos?.composition || [refIndic[setRef].id];

	if (!composition || !composition.length) {
		return null;
	}
	const featureCompo = propFeature.id_meta.split("_")[0].toUpperCase();

	data = barData(propFeature);
	if (!isEmpty(infosCompare) && timeActivated) {
		const propFeatureCompare = infosCompare?.properties;
		if (propFeatureCompare?.date_data !== propFeature?.date_data) {
			data = [...data, ...barData(propFeatureCompare, "#a23f97")];
		}
	}
	// ordonner les barres dans le graphique avec le niveau le plus haut en bas
	// permet d'avoir la composante cliquée en bas ou l'indice thématique cliqué en bas
	data = sortBy(data, ["ref", (d) => parseInt(d.year)]);
	data = sortBy(data, [({niveau}) => -niveau]);
	

	// cas spécial pour les indices transverses - l'indice doit être en dernier
	if(refIndicInfos.composante == "IT") {
		data = data.reverse();
		let indiceIT = data.filter(d => d.composante === "IT");
		data = data.filter(d => d.composante !== "IT");
		data = [...indiceIT, ...data];
	}

	// Calcul dynamique de la hauteur selon le nombre d’éléments
	const chartHeight = Math.max(140, data.length * 30);

	let layout = {
		title: "",
		xaxis: {
			range: [0, 5],
			zeroline: true,
			showgrid: true,
			dtick: 1,
			title: "Valeur",
		},
		yaxis: {
			automargin: true,
			tickangle: 0, // Texte lisible sans inclinaison
		},
		autosize: false,
		height: chartHeight, // Ajustement dynamique de la hauteur
		responsive: true,
		showlegend: false,
		margin: {
			l: 200, // Augmentation de la marge gauche pour la lisibilité
			r: 50,
			t: 30,
			b: 50,
		},
	};

	let config = {
		displayModeBar: false,
	};

	return (
		<div 
			className="charts-container"
			style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }} // Activation du scroll

		>
			<ListGroupItem tag="div">
				<Plot
					data={data}
					layout={layout}
					useResizeHandler={true}
					style={{ width: "100%", height: "100%", maxHeight: 200 }}
					config={config}
				/>
			</ListGroupItem>
		</div>
	);
}
